import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import Icon from '../../@shared/icon';
import { useMenuDispatcher } from '../menuContext';
import RoutableSitecoreLink from '../../@shared/routableSitecoreLink';
import { googleClickCtaEvent } from '../../../utils/analytics';

const FindADealer = ({ fields }: { fields: ComponentFieldsGeneral }): JSX.Element => {
  const dispatchToProvider = useMenuDispatcher();
  const handleClick = (): void => {
    dispatchToProvider({ type: 'closeAll' });
  };

  return (
    <li className="navigation__menu-item">
      <RoutableSitecoreLink
        field={fields?.findDealer?.link}
        onClick={(): void => {
          handleClick();
          googleClickCtaEvent('Global Nav', fields?.findDealer?.link?.value?.text, fields?.findDealer?.link?.value?.text);
        }}
        className="navigation__menu-item__trigger"
      >
        <span className="navigation__menu-item__trigger__content navigation__menu-item__trigger__content--with-icon">
          <Icon iconField={fields?.findDealer?.icon} extraClassName="navigation__menu-item__trigger__icon" size={22} />
          <RichText tag="span" className="navigation__menu-item__trigger__text rich-text" field={fields?.findDealer?.title} />
        </span>
      </RoutableSitecoreLink>
    </li>
  );
};

export default FindADealer;
